// utils/dayjs.ts
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// (opcional) establecer zona horaria por defecto, por ejemplo Colombia (UTC-5)
dayjs.tz.setDefault("America/Bogota");

export default dayjs;
